var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSshkeyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 1.5L14.25 3M14.25 3L16.5 5.25L13.875 7.875L11.625 5.625M14.25 3L11.625 5.625M8.54249 8.7075C8.92975 9.0896 9.23759 9.54453 9.44831 10.0461C9.65902 10.5477 9.76844 11.0859 9.77026 11.63C9.77209 12.174 9.66628 12.713 9.45893 13.216C9.25158 13.7189 8.94679 14.1759 8.5621 14.5606C8.17742 14.9453 7.72043 15.2501 7.21747 15.4574C6.7145 15.6648 6.17549 15.7706 5.63147 15.7688C5.08744 15.7669 4.54915 15.6575 4.04759 15.4468C3.54602 15.2361 3.09109 14.9283 2.70899 14.541C1.95759 13.763 1.54181 12.721 1.55121 11.6395C1.56061 10.5579 1.99443 9.52331 2.75924 8.7585C3.52405 7.99369 4.55865 7.55987 5.64021 7.55047C6.72177 7.54107 7.76376 7.95685 8.54174 8.70825L8.54249 8.7075ZM8.54249 8.7075L11.625 5.625",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSshkeyIcon);
export default __webpack_public_path__ + "static/media/sshkey-icon.708ce233853d634bc6e9538a293e6d8c.svg";
export { ForwardRef as ReactComponent };